import { createI18n } from "vue-i18n";
import enUS from "./text/en-US.json";
import zhTW from "./text/zh-TW.json";
import jaJP from "./text/ja-JP.json";
import store from "../store";
//正在導出的語言
let locale = process.env.VUE_APP_I18N_LOCALE || "zh-TW"||"ja-JP";
if (localStorage.getItem("i18n")) {
  const localeData = localStorage.getItem("i18n");
  locale = localeData !== null ? localeData : process.env.VUE_APP_I18N_LOCALE;
}
store.commit("langModule/CHANGE_LANG", locale);

export default createI18n({
  // 使用 Composition API 須設定此變數為 false
  legacy: false,
  globalInjection: true,//全域注入
  locale: locale,
  fallbackLocale: locale,
  warnHtmlInMessage: "off",
  messages: {
    "zh-TW": zhTW,
    "en-US": enUS,
    "ja-JP": jaJP,
  },
});
